import { supabase } from '../auth/supabase.ts';
import { syncNow } from '../sync/sync.ts';
import { useSyncStatus } from '../sync/status.ts';

/**
 * Tells the user whether her work has left the tablet.
 *
 * Without this the offline-first design is unnerving rather than reassuring:
 * edits made with no network look identical to edits that were saved, and the
 * only way to find out is to open the other device.
 */
export function SyncBadge() {
  const phase = useSyncStatus((s) => s.phase);
  const pending = useSyncStatus((s) => s.pending);

  if (phase === 'disabled') return null;

  const label =
    phase === 'syncing'
      ? 'Synchronisation…'
      : phase === 'offline'
        ? pending
          ? `Hors ligne • ${pending} à envoyer`
          : 'Hors ligne'
        : phase === 'error'
          ? pending
            ? `Non synchronisé • ${pending}`
            : 'Non synchronisé'
          : phase === 'signed-out'
            ? 'Déconnectée'
            : pending
              ? `${pending} à envoyer`
              : 'À jour';

  const tone =
    phase === 'error' ? 'error' : phase === 'offline' ? 'offline' : pending ? 'pending' : 'ok';

  return (
    <button
      class={`syncBadge ${tone}`}
      title={
        phase === 'error'
          ? 'La dernière synchronisation a échoué. Tes données restent sur l’appareil.'
          : 'Synchroniser maintenant'
      }
      onClick={() => void syncNow()}
    >
      <span class="syncDot" />
      <span class="syncLabel">{label}</span>
    </button>
  );
}

/** Sign-out control, shown on the Compte page rather than in the top bar. */
export function SignOutButton() {
  const phase = useSyncStatus((s) => s.phase);
  const pending = useSyncStatus((s) => s.pending);

  const client = supabase;
  if (phase === 'disabled' || !client) return null;

  return (
    <button
      class="btn ghost"
      onClick={async () => {
        // Signing out clears the local store's account binding, so unsent work
        // would be stranded. Better to say so than to discover it later.
        if (
          pending > 0 &&
          !confirm(
            `${pending} modification(s) ne sont pas encore synchronisées. Se déconnecter quand même ?`,
          )
        ) {
          return;
        }
        await client.auth.signOut();
      }}
    >
      Se déconnecter
    </button>
  );
}
